import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { analyticsApi } from 'src/services/analyticsApi'

interface UseGetInboxAvailablePlatformsParams {
  enabled?: boolean
  fromDate?: string
  // Omit to aggregate across all of the user's inbox pages.
  pageId?: string
  toDate?: string
}

interface AvailablePlatformsResponse {
  platforms: string[]
}

export const useGetInboxAvailablePlatformsQuery = (
  params: UseGetInboxAvailablePlatformsParams = {}
) => {
  return useQuery<string[]>({
    enabled: params.enabled !== false,
    queryFn: async () => {
      const { data } = await analyticsApi().get<AvailablePlatformsResponse>(
        '/v1_private/inbox-analysis/available-platforms',
        {
          params: {
            fromDate: params.fromDate,
            pageId: params.pageId,
            toDate: params.toDate,
          },
        }
      )
      return data?.platforms ?? []
    },
    queryKey: [
      QueryKey.GET_INBOX_AVAILABLE_PLATFORMS,
      params.pageId,
      params.fromDate,
      params.toDate,
    ],
  })
}
